/// <reference types="google.maps" />

import { useEffect, useState } from "react";
import { TerraDraw, TerraDrawPolygonMode, TerraDrawSelectMode } from "terra-draw";
import { TerraDrawGoogleMapsAdapter } from "terra-draw-google-maps-adapter";

type SelectModeOptions = {
  flags?: {
    polygon?: {
      feature?: {
        draggable?: boolean;
        rotateable?: boolean;
        coordinates?: {
          midpoints?: boolean | { draggable?: boolean };
          draggable?: boolean;
          deletable?: boolean;
        };
      };
    };
  };
};

type SelectModeConstructor = new (options?: SelectModeOptions) => TerraDrawSelectMode;
type PolygonModeConstructor = new () => TerraDrawPolygonMode;

const SafeTerraDrawSelectMode = TerraDrawSelectMode as unknown as SelectModeConstructor;
const SafeTerraDrawPolygonMode = TerraDrawPolygonMode as unknown as PolygonModeConstructor;

const useTerraDraw = ({ map }: { map: google.maps.Map | null }) => {
  const [terraDraw, setTerraDraw] = useState<TerraDraw | null>(null);

  useEffect(() => {
    if (!map) return;

    let td: TerraDraw | null = null;

    const initialize = () => {
      if (td) return;

      td = new TerraDraw({
        adapter: new TerraDrawGoogleMapsAdapter({ map, lib: google.maps }),
        modes: [
          new SafeTerraDrawSelectMode({
            flags: {
              polygon: {
                feature: {
                  draggable: true,
                  rotateable: true,
                  coordinates: {
                    midpoints: true,
                    draggable: true,
                    deletable: true,
                  },
                },
              },
            },
          }),
          new SafeTerraDrawPolygonMode(),
        ],
      });
      setTerraDraw(td);
    };

    const idleListener = google.maps.event.addListener(map, "idle", initialize);

    if (map.getBounds()) initialize();

    return () => {
      google.maps.event.removeListener(idleListener);
      if (td?.enabled) {
        td.clear();
      }
    };
  }, [map]);

  return terraDraw;
};

export default useTerraDraw;
